module.exports = __webpack_public_path__ + "assets/img/3e26f8079fab51fe1d79e7bec8443bd2.png";